module.exports = __webpack_public_path__ + "img/Bitmap@2x.1dda04eb.png";